module.exports = __webpack_public_path__ + "img/20201014_120656.9921abf7.jpg";